export default {
  trends: {
    title: "Tendencia de precios",
    subtitleBase: "Tendencia estimada del PVL a partir del histórico real (SNS Genéricos 2010+ y PMAH).",
    disclaimer: "Estimación estadística de tendencia, no una predicción regulatoria ni un compromiso: orienta, no decide. Los hitos futuros con fecha están en el Calendario.",
    products: "productos",
    upTo: "hasta",
    yearsUnit: "años",
    ofHistory: "de histórico",
    horizonMonths: "{n} meses",
    // Estados de carga / error / vacío
    calculating: "Calculando tendencias…",
    calculatingDetail: "Cargando histórico real, detectando eventos y entrenando modelos.",
    noDataTitle: "Sin datos suficientes para estimar la tendencia",
    noDataDetail: "Se necesitan al menos 3 observaciones de precio (SNS Genéricos o PMAH) por CN. Cuando el histórico crezca verás la tendencia aquí.",
    // Selector de producto
    searchPlaceholder: "Buscar entre {n} productos (nombre o CN)…",
    noResults: "Sin resultados para «{query}»",
    moreHint: "+{n} más — afina la búsqueda",
    // Gráfica de forecast
    model: "Modelo",
    chartHist: "Histórico",
    chartForecast: "Tendencia estimada",
    bandInterval: "Intervalo 90%",
    histPrice: "Precio histórico",
    forecastLine: "Tendencia estimada",
    // Panel oportunidad / riesgo
    marketOpportunity: "Oportunidad de mercado",
    opportunity: "Oportunidad",
    noStrongSignals: "Sin señales fuertes detectadas",
    riskOneMonth: "Riesgo a 1 mes",
    riskSpike: "Subida brusca",
    riskDrop: "Caída brusca",
    riskAnomaly: "Anomalía",
    // Ranking + drivers
    opportunityRanking: "Ranking de oportunidad (top {n})",
    scoreLabel: "Score",
    detectedEvents: "Eventos detectados (drivers)",
    noEvents: "Sin eventos identificados.",
    // Backtest
    backtestTitle: "Validación temporal — backtest",
    thModel: "Modelo",
    thHorizon: "Horizonte",
    thDirAcc: "Acierto direccional",
    // Etiquetas de eventos (drivers)
    eventGenericEntry: "Entrada genérico",
    eventPatentExpiration: "Expiración patente",
    eventRegulatoryApproval: "Aprobación regulatoria",
    eventRegulatoryRejection: "Rechazo regulatorio",
    eventSafetyAlert: "Alerta de seguridad",
    eventWithdrawal: "Retirada",
    eventShortage: "Desabastecimiento",
    eventReimbursementChange: "Cambio reembolso",
    eventExclusion: "Exclusión PMAH",
    eventMergerAcquisition: "Fusión / adquisición",
    eventLicenseAgreement: "Acuerdo de licencia",
    eventProductionChange: "Cambio producción",
    eventLogisticsDisruption: "Interrupción logística",
    eventDemandChange: "Cambio de demanda",
    eventGeopoliticalSupply: "Riesgo de suministro",
    eventManufacturerConcentration: "Concentración fabricantes",
  },
};
